module.exports = __webpack_public_path__ + "assets/images/4b5606c40172ec538a76fa48404816d9.png";